import InputBar from './InputBar';
export default InputBar;